import {makeStyles} from '@material-ui/core';

export const useQuotingCardStyles = makeStyles(() => ({
  cardWrapper: {
    padding: '2rem',
  },
  card: {
    marginBottom: '1rem',
    borderBottomLeftRadius: '0',
    borderBottomRightRadius: '0',
  },
}));

export const useCustomCardHeaderStyles = makeStyles(() => ({
  header: {
    display: 'flex',
    backgroundColor: '#f1f1f1',
    color: '#0033A0',
    width: '100%',
    fontWeight: 600,
    textAlign: 'left',
    borderBottom: '1px solid #ccc',
    padding: '1.25rem 1.75rem',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  title: {
    color: '#0033A0',
    fontSize: '1rem',
  },
  subtitle: {
    color: '#0033A0',
    fontSize: '1.125rem',
  },
}));

export const useCardActionStyles = makeStyles(() => ({
  cardActions: {
    justifyContent: 'flex-end',
    padding: '1.5rem',
    fontSize: 500,
    borderTop: '1px solid #ccc',
  },

  actions: {
    display: 'flex',
    '& > *': {
      margin: '0 0.5rem',
    },
  },
}));
